import React from "react";
import Hero from "./Hero";
import Community from "../../components/Community";

const Science = () => {
    return (
        <>
            <Hero />
            <Community />
        </>
    );
};

export default Science;
